import React, { useMemo, useState } from 'react'

const MySelect = ({ input, onSelectChange, onInputChange }) => {
    const { id, text, options, value } = input

    const initialSelect = useMemo(() => {
        if (!value) return ''
        const exists = options?.some((o) => o.text === value)
        return exists ? value : (value === 'другое' ? 'другое' : '')
    }, [options, value])

    const [isActiveInput, setIsActiveInput] = useState(value === 'другое')
    const [selectValue, setSelectValue] = useState(initialSelect)

    return (
        <label className="my-select-label">
            <span className="_question-text _no-wrap">{id + 1}. {text}:</span>

            <div className="my-select-with-input">
                <select
                    className="my-select"
                    value={selectValue}
                    onChange={(event) => { setSelectValue(event.target.value); onSelectChange(id, event, setIsActiveInput) }}
                >
                    <option className="my-select__option" value="">Выберите вариант</option>
                    {options.map((option) => (
                        <option key={option.id} className="my-select__option" value={option.text}>{option.text}</option>
                    ))}
                </select>

                {isActiveInput && (
                    <input
                        className="my-bottom-input"
                        placeholder="введите свой вариант"
                        onChange={(event) => onInputChange(id, event)}
                    />
                )}
            </div>
        </label>

    )
}

export default React.memo(MySelect)